// Account security (ADR 0037): one-time links, changing your own password, and two-factor
// resets decided by a second administrator.
import {
  accountLinkViewSchema,
  issuedAccountLinkSchema,
  redeemAccountLinkResultSchema,
  twoFactorResetListSchema,
  twoFactorResetSchema,
  userSecuritySchema,
  userSummarySchema,
} from '@wodi/shared';
import { queryOptions } from '@tanstack/react-query';

import { api } from './client.ts';

export function inspectAccountLink(token: string) {
  return api('POST', '/auth/account-link/inspect', {
    body: { token },
    schema: accountLinkViewSchema,
  });
}

export function redeemAccountLink(token: string, password: string) {
  return api('POST', '/auth/account-link/redeem', {
    body: { token, password },
    schema: redeemAccountLinkResultSchema,
  });
}

export function changePassword(currentPassword: string, newPassword: string) {
  return api('POST', '/auth/password', { body: { currentPassword, newPassword } });
}

export const userQuery = (userId: string) =>
  queryOptions({
    queryKey: ['users', userId],
    queryFn: () => api('GET', `/users/${userId}`, { schema: userSummarySchema }),
  });

export const userSecurityQuery = (userId: string) =>
  queryOptions({
    queryKey: ['users', userId, 'security'],
    queryFn: () => api('GET', `/users/${userId}/security`, { schema: userSecuritySchema }),
  });

export const openTwoFactorResetsQuery = queryOptions({
  queryKey: ['two-factor-resets'],
  queryFn: () => api('GET', '/two-factor-resets', { schema: twoFactorResetListSchema }),
});

export function issuePasswordResetLink(userId: string) {
  return api('POST', `/users/${userId}/password-reset-links`, { schema: issuedAccountLinkSchema });
}

export function requestTwoFactorReset(userId: string, reason: string) {
  return api('POST', `/users/${userId}/two-factor-resets`, {
    body: { reason },
    schema: twoFactorResetSchema,
  });
}

export function decideTwoFactorReset(resetId: string, decision: 'approve' | 'reject') {
  return api('POST', `/two-factor-resets/${resetId}/${decision}`, {
    body: {},
    schema: twoFactorResetSchema,
  });
}
